const PREDEFINED_TAGS = [
  '熱門項目',
  '預約專享',
  '會員獨享',
  '新人優惠',
  '獨家推薦',
  '團購專享',
  '福利活動',
  '公益活動',
  'APP活動'
]

const categories = [
  { name: '全部', type: 'all' },
  { name: '美甲', type: 'nail' },
  { name: '美髮', type: 'hair_care' },
  { name: '美睫', type: 'eyelash' },
  { name: '美容', type: 'beauty_salon' },
  { name: '彩妝', type: 'makeup' },
  { name: '牙齒美容', type: 'dental' },
  { name: '紋繡', type: 'eyebrown' },
  { name: '除毛', type: 'shaving' },
  { name: '按摩', type: 'spa' },
  { name: '其他', type: 'other' }
]

export { PREDEFINED_TAGS, categories }
